// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1H5Xy","options":"AnswerScale_options__3UQ0z","selected":"AnswerScale_selected__3GJoG"};